import React, { FC } from 'react'

import { ExpectedPerformanceChart } from 'mf-ui-components'

import rawlang, * as l10n from '../../../../utils/l10n'
import { ChartData } from './types'
import { ChartContainer } from './ExpectedPerformance.styles'
import { getCompactCurrency } from '../../../../utils/currency'
import { getLocaleFromCountry } from '../../../../utils/locale'

const lang = rawlang as 'en' | 'it'

type Props = {
  chartData: ChartData
  yFormat: (value: number) => string
}

export const Chart: FC<Props> = ({ chartData, yFormat }) => (
  <ChartContainer>
    <ExpectedPerformanceChart
      variant="default"
      chartAreasLegend="compact"
      chartLinesLegend="extended"
      chartAreasLegendText={{
        areasLegendExtendedHeading: '',
        highConfidenceGenericText: l10n.expected_performance.more_likely[lang],
        lowConfidenceGenericText: l10n.expected_performance.less_likely[lang],
        lowConfidenceYHighText: '',
        highConfidenceYHighText: '',
        highConfidenceYLowText: '',
        lowConfidenceYLowText: '',
      }}
      chartLineForContribution={chartData.totalContribution}
      chartLineForProjection={chartData.expectedValue}
      chartTooltipText={{
        yearText: l10n.expected_performance.year_by[lang],
        projectionText: l10n.expected_performance.projected_value[lang],
        contributionText: l10n.expected_performance.contribution[lang],
      }}
      showChartLinesLegend
      yAxisFormatter={(value: number) =>
        getCompactCurrency(
          getLocaleFromCountry(process.env.GATSBY_COUNTRY),
          process.env.GATSBY_CURRENCY,
          value
        )
      }
      xAxisFormatter={(value: Date) => value.getFullYear().toString()}
      yFormat={yFormat}
    />
  </ChartContainer>
)
